import './home.less'

import {Background, Image} from '@codeurs/front'
import imecLogo40yearsWhite from 'assets/images/imec-logo-40years-white.svg'
import itfLogoWhite from 'assets/images/itf-logo-white.svg'
import {Block, BlockType} from 'blocks/block'
import {Blocks} from 'blocks/blocks'
import React from 'react'
import {ImageType, PageData} from 'types'
import {Link} from 'util/link'
import {style} from 'util/style'
import {TrackingContext} from 'util/trackers'
import {Tracking} from 'util/tracking'
import {Trusted} from 'util/trusted'
import {CookiehubContextProvider} from 'util/useCookiehub'
import {Cookiewarning} from 'views/layout/cookiewarning'
import {Theme} from 'views/theme'

// import imecLogoWhite from 'assets/images/imec-logo-white.svg'

const styles = style('home', ['header', 'hero'])

type HeroType = {
	image?: ImageType
	image_overlay?: number
	description: string
}

export const Home: React.FC<PageData & {
	hero: HeroType
	blocks: Array<BlockType>
}> = data => {
	const {title, hero, blocks} = data

	return (
		<div className={styles()}>
			<Header />
			<Hero {...hero} description={hero?.description || title} />
			<Blocks className={styles('blocks')}>
				{blocks.map((block, i) => (
					<Block key={i} {...block} />
				))}
			</Blocks>
			<CookiehubContextProvider>
				<TrackingContext.Provider value={{url: data.url, title: data.title}}>
					<Tracking view={Cookiewarning} project={data.project_key} />
				</TrackingContext.Provider>
			</CookiehubContextProvider>
		</div>
	)
}

const Header: React.FC = () => {
	return (
		<div className={styles.header()}>
			<Theme.OuterContainer>
				<div className={styles.header('row')}>
					<div className={styles.header('row-left')}>
						<div className={styles.header('row-left-logo')}>
							<Image {...itfLogoWhite} alt="itf logo" />
						</div>
					</div>
					<div className={styles.header('row-right')}>
						<Link
							to="https://www.imec-int.com"
							target="_blank"
							className={styles.header('row-right-powered')}
							title="imec corporate website"
						>
							<span>Powered by</span>
							<span className={styles.header('row-right-powered-logo')}>
								{/* <Image {...imecLogoWhite} alt="imec logo"/> */}
								<Image {...imecLogo40yearsWhite} alt="imec logo" />
							</span>
						</Link>
					</div>
				</div>
			</Theme.OuterContainer>
		</div>
	)
}

const Hero: React.FC<HeroType> = ({image, image_overlay = 0, description}) => {
	return (
		<div className={styles.hero()}>
			{image && !image.empty && (
				<>
					<div className={styles.hero('bg')}>
						<Background img={image} />
					</div>
					<span
						className={styles.hero('overlay')}
						style={{opacity: image_overlay / 100}}
					/>
				</>
			)}
			<div className={styles.hero('content')}>
				<Theme.Container>
					{description && (
						<h1 className={styles.hero('content-description')}>
							<Trusted>{description}</Trusted>
						</h1>
					)}
					<Theme.Button
						href="#upcoming-itfs"
						mod={['gradient']}
						className={styles.hero('content-button')}
					>
						<Theme.ButtonText>Upcoming ITFs</Theme.ButtonText>
						<Theme.ButtonIcon icon="arrow-right" />
					</Theme.Button>
				</Theme.Container>
			</div>
		</div>
	)
}
